var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComida(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEC9A3"
    },
    d: "M320.816,407.864l99.293-70.925c11.307-8.088,27.023-5.476,35.111,5.832 c0.399,0.555,0.772,1.128,1.119,1.71l0,0c6.777,11.281,3.714,25.878-7.02,33.488l-105.377,87.344 c-9.337,7.741-21.087,11.976-33.219,11.976H95.189V373.153l42.409-35.345c6.239-5.198,14.102-8.044,22.224-8.044h113.265 c11.984,0,21.695,9.711,21.695,21.695l0,0c0,11.984-9.711,21.695-21.695,21.695H216.68c-9.589,0-17.356,7.767-17.356,17.356l0,0 c0,9.589,7.767,17.356,17.356,17.356H320.816z"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 364.475,
    style: {
      fill: "#4398D1"
    },
    width: 95.189,
    height: 147.525
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#E5E5E5"
    },
    cx: 43.39,
    cy: 459.932,
    r: 17.356
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1D1D1"
    },
    d: "M8.678,277.695H512l0,0l0,0c0,28.759-23.309,52.068-52.068,52.068H60.746 C31.987,329.763,8.678,306.454,8.678,277.695L8.678,277.695L8.678,277.695z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5E5E5"
    },
    d: "M477.288,277.695H43.39v-8.678c0-119.817,97.132-216.949,216.949-216.949l0,0 c119.817,0,216.949,97.132,216.949,216.949V277.695z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M115.417,173.629l-14.484-9.546c5.042-7.619,10.622-14.865,16.696-21.695l12.974,11.524 C125.084,160.117,120.008,166.704,115.417,173.629z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M141.607,142.536l-11.88-12.644c35.328-33.306,82.059-51.842,130.612-51.79v17.356 C216.203,95.414,173.724,112.258,141.607,142.536z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D1D1D1"
    },
    points: "286.373,0 234.305,0 234.305,17.356 251.661,17.356 251.661,52.068 269.017,52.068  269.017,17.356 286.373,17.356 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C9C9C9"
    },
    d: "M386.612,277.695c-48.31,24.576-99.892,42.105-153.175,52.068h226.495 c28.759,0,52.068-23.309,52.068-52.068H386.612z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DEDEDE"
    },
    d: "M477.288,269.017c0.052-59.713-24.576-116.788-68.061-157.713 c-60.867,86.875-171.06,138.769-249.457,166.391h317.518V269.017z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7BB8F"
    },
    d: "M457.598,347.119c-0.364-0.894-0.79-1.762-1.258-2.603c-7.142-11.924-22.597-15.803-34.521-8.661 c-0.581,0.347-1.154,0.72-1.71,1.119l-14.249,10.145H457.598z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7BB8F"
    },
    d: "M294.339,347.119c-2.065-10.101-10.943-17.356-21.252-17.356H159.822 c-8.123,0-15.985,2.846-22.224,8.044l-11.169,9.311H294.339z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComida);
export default __webpack_public_path__ + "static/media/comida.ba0896121046bcb9bfe5b8944ee0a6ff.svg";
export { ForwardRef as ReactComponent };